import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const simulate = (payload = {}) => {
  return responseFormatter(
    http.post(`/notify`, payload, {
      setAuthHeader: true,
    })
  );
};

const getSimulatePayload = (notificationId) => {
  return responseFormatter(
    http.get(`/notifications/${notificationId}/simulate-payload `, {
      setAuthHeader: true,
    })
  );
};

const Service = {
  simulate,
  getSimulatePayload
};

export default Service;
